export const ProductApiKey = {
  createProduct: "create new product",
  deleteProduct: "delete product",
  updateProduct: "update product",
  duplicateProduct: "duplicate product",
};
